import { Button } from '@storeblocks/button';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';
import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  onClick(): void;
}
export const CloseButton: FC<Props> = ({ onClick }) => {
  const texts = useTexts();
  const getTrackId = useGetTrackId();

  return (
    <Button
      onClick={onClick}
      variant="subtle"
      data-test="close-add-funds-modal"
      data-trackid={getTrackId(
        'cancel:add-funds-modal',
        TrackingElement.Button,
      )}
    >
      {texts.orders.form.addFundModal.button.cancel}
    </Button>
  );
};
